/**
 * Parses a slug path into its component parts.
 * Examples:
 *   "clinic-name" -> { rootSlug: "clinic-name", subSlug: null, parts: ["clinic-name"] }
 *   "clinic-name/room-1" -> { rootSlug: "clinic-name", subSlug: "room-1", parts: ["clinic-name", "room-1"] }
 *   "" -> { rootSlug: null, subSlug: null, parts: [] }
 */ export var parseSlugParts = function(slug) {
    var parts = slug.split('/').filter(Boolean);
    var _parts_, _parts_1;
    return {
        rootSlug: (_parts_ = parts[0]) !== null && _parts_ !== void 0 ? _parts_ : null,
        subSlug: (_parts_1 = parts[1]) !== null && _parts_1 !== void 0 ? _parts_1 : null,
        parts: parts
    };
};
/**
 * Extracts the root slug (first path segment) from a full slug path.
 * Examples:
 *   "clinic-name" -> "clinic-name"
 *   "clinic-name/room-1" -> "clinic-name"
 *   "clinic-name/room-1/extra" -> "clinic-name"
 *   "" -> null
 *   "/" -> null
 */ export var extractRootSlug = function(slug) {
    return parseSlugParts(slug).rootSlug;
};
